<template>
    <div>
      <card class="card1">
          <p>{{ copyright }}</p>
      </card>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        copyright:
          "Todos los derechos revservados a @Dobladora & Cortadora Santa Fé S.A.S",
      };
    },
  };
  </script>
  <style scoped>
  .card1{
    padding: 0;
    font-size:small;
    justify-content: center;
    color: black;
    margin-top: 1px;
  }
  </style>  